module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic-ext46.47734ae.woff2";